import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Injectable({providedIn: 'root'})
@Pipe({
  name: 'yesOrNo'
})
export class YesOrNoPipe implements PipeTransform {
  transform(value: unknown): string {
    return value ? 'Yes' : 'No';
  }

}
